import { render, staticRenderFns } from "./TheThgProcessingList.vue?vue&type=template&id=62800b86&scoped=true&"
import script from "./TheThgProcessingList.vue?vue&type=script&lang=ts&"
export * from "./TheThgProcessingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62800b86",
  null
  
)

export default component.exports